"use strict";

var config = require("app/util/config/config");
var APICaller = require("./api-caller");

module.exports = new APICaller(config.app.apiRailsURL);



// WEBPACK FOOTER //
// ./app/util/api/agendor-api.js